(function () {
  const header = document.querySelector(".site-header");
  const toggle = document.querySelector(".menu-toggle");
  const nav = document.getElementById("site-nav");
  const backdrop = document.querySelector(".nav-backdrop");

  if (header && toggle && nav && backdrop) {
    const focusableSelector =
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

    let savedScrollY = 0;

    function resetHorizontalScroll() {
      window.scrollTo(0, window.scrollY);
      document.documentElement.scrollLeft = 0;
      document.body.scrollLeft = 0;
    }

    function lockPageScroll() {
      savedScrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
    }

    function unlockPageScroll() {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      window.scrollTo(0, savedScrollY);
      resetHorizontalScroll();
    }

    function focusWithoutScroll(element) {
      if (!element) return;
      try {
        element.focus({ preventScroll: true });
      } catch {
        element.focus();
      }
    }

    function isMobileNav() {
      return window.innerWidth <= 900;
    }

    function syncNavInert(isOpen) {
      nav.inert = isMobileNav() && !isOpen;
    }

    function setNavOpen(isOpen) {
      header.classList.toggle("is-nav-open", isOpen);
      toggle.setAttribute("aria-expanded", String(isOpen));
      backdrop.hidden = !isOpen;
      document.body.classList.toggle("nav-open", isOpen);
      syncNavInert(isOpen);

      if (isOpen) {
        resetHorizontalScroll();
        lockPageScroll();
        requestAnimationFrame(() => {
          focusWithoutScroll(nav.querySelector(focusableSelector));
        });
      } else {
        unlockPageScroll();
        if (isMobileNav()) {
          focusWithoutScroll(toggle);
        }
      }
    }

    toggle.addEventListener("click", () => {
      const isOpen = !header.classList.contains("is-nav-open");
      setNavOpen(isOpen);
      toggle.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
    });

    backdrop.addEventListener("click", () => setNavOpen(false));

    document.querySelector(".nav-close")?.addEventListener("click", () => setNavOpen(false));

    nav.querySelectorAll(".primary-nav-links a, .primary-nav > a").forEach((link) => {
      link.addEventListener("click", () => setNavOpen(false));
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && header.classList.contains("is-nav-open")) {
        setNavOpen(false);
      }
    });

    window.addEventListener("resize", () => {
      if (!isMobileNav() && header.classList.contains("is-nav-open")) {
        setNavOpen(false);
      } else {
        syncNavInert(header.classList.contains("is-nav-open"));
      }
    });

    syncNavInert(false);
  }

  initNavScrollSpy();
})();

function initNavScrollSpy() {
  const navLinks = document.querySelectorAll(".primary-nav-links a[href*='#']");
  if (!navLinks.length) return;

  const sections = [];

  navLinks.forEach((link) => {
    const hash = link.getAttribute("href").split("#")[1];
    if (!hash) return;
    const section = document.getElementById(hash);
    if (section) sections.push({ id: hash, link, section });
  });

  if (!sections.length) return;

  function setActive(id) {
    sections.forEach(({ id: sectionId, link }) => {
      link.classList.toggle("is-active", sectionId === id);
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

      if (visible.length) {
        setActive(visible[0].target.id);
        return;
      }

      const scrollY = window.scrollY + 120;
      let current = null;
      sections.forEach(({ id, section }) => {
        if (section.offsetTop <= scrollY) current = id;
      });
      setActive(current);
    },
    { rootMargin: "-35% 0px -55% 0px", threshold: [0, 0.15, 0.35] }
  );

  sections.forEach(({ section }) => observer.observe(section));
}
